module.exports = __webpack_public_path__ + "img/forgot-password-v2.a65d8473.svg";